import { render, staticRenderFns } from "./SpouseInfo.vue?vue&type=template&id=4e74ad3e&scoped=true&"
import script from "./SpouseInfo.vue?vue&type=script&lang=js&"
export * from "./SpouseInfo.vue?vue&type=script&lang=js&"
import style0 from "./SpouseInfo.vue?vue&type=style&index=0&id=4e74ad3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e74ad3e",
  null
  
)

export default component.exports